import { partialDateToValue } from 'neuro-utils';
import React from 'react';
import { useIntl } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const StyledDateRange = ({ from, to, controls }: IOwnProps) => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ alignSelf: 'flex-end' }}>
        {controls?.from}
        <div style={{ fontWeight: 600 }}>{formatPartialDate(from)}</div>
        <div style={{ textAlign: 'center' }}>{fm(`general.jsDate.${new Date(partialDateToValue(from)).getDay()}`)}</div>
      </div>
      <div style={{ margin: '0 1rem', alignSelf: controls?.from || controls?.to ? 'center' : 'flex-start' }}>{'-'}</div>
      <div style={{ alignSelf: 'flex-end' }}>
        {controls?.to}
        <div style={{ fontWeight: 600 }}>{formatPartialDate(to)}</div>
        <div style={{ textAlign: 'center' }}>{fm(`general.jsDate.${new Date(partialDateToValue(to)).getDay()}`)}</div>
      </div>
    </div>
  );
};

interface IOwnProps {
  from: PartialDate;
  to: PartialDate;
  controls?: {
    from?: React.JSX.Element;
    to?: React.JSX.Element;
  };
}

export default StyledDateRange;
